import React from 'react';

interface LegendItem {
  type: string;
  label: string;
  color: string;
  icon?: string;
}

interface MapLegendProps {
  items: LegendItem[];
  position?: 'topright' | 'topleft' | 'bottomright' | 'bottomleft';
}

const MapLegend: React.FC<MapLegendProps> = ({ items, position = 'bottomright' }) => {
  const positionClasses = {
    topright: 'top-4 right-4',
    topleft: 'top-4 left-4',
    bottomright: 'bottom-4 right-4',
    bottomleft: 'bottom-4 left-4',
  };

  return (
    <div className={`absolute ${positionClasses[position]} bg-white rounded-lg shadow-lg p-4 z-[1000] max-w-xs`}>
      <h4 className="text-sm font-semibold text-gray-900 mb-3">ตำนานแผนที่ (Legend)</h4>
      <div className="space-y-2">
        {items.map((item) => (
          <div key={item.type} className="flex items-center gap-2">
            <div
              className="w-4 h-4 rounded-full flex-shrink-0"
              style={{ backgroundColor: item.color }}
            />
            <span className="text-xs text-gray-700">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapLegend;
